/* eslint-disable prefer-template, arrow-body-style, quote-props */
import { isDebugModeEnabled } from 'es6/controllers/apps/debug-overrides';
import ItemQuizBase from 'es6/controllers/apps/quizzes/item-quiz-base';
import Logger from 'es6/services/logger';
import RapidChoiceComponent from 'es6/components/apps/screens/rapid-choice';
import { ResultTypes } from 'es6/models/quiz-result';

/**
 * @this RapidChoiceBase
 * @param {Boolean} isCorrect
 * @param {Number} choiceMade     index of the choice made
 */
function handleAnswer(isCorrect, choiceMade) {
  this._quizTimer.finished = null;
  this._quizTimer.pause();
  this.updateQuizData({ choiceMade });
  this.result.setResult(isCorrect ? ResultTypes.CORRECT : ResultTypes.INCORRECT);
  this.result.beginPhase('confirmation');
}

/**
 * TODO: Put this logic
 *
 * @this RapidChoiceBase
 */
function handleTimeout() {
  this.result.setResult(ResultTypes.TIMEOUT);
  this.result.beginPhase('confirmation');
  renderComponent.call(this);
}

/**
 * @this RapidChoiceBase
 * @param {Function} onLoaded
 */
function renderComponent(onLoaded) {
  const { answer, choices, recallPrompt } = this;
  const props = {
    correctChoiceIndex: choices.indexOf(answer),
    choices,
    onAnswer: handleAnswer.bind(this),
    onQuizFinished: this.finishQuiz.bind(this),
    recallPrompt,
    recallPromptSound: this.recall === 'cue' ? this.itemPackage.sound : null,
    timedOut: this.result.isTimeout(),
  };

  this._screenManager.renderComponent(RapidChoiceComponent, props, onLoaded);
}

class RapidChoiceBase extends ItemQuizBase {
  constructor(itemPackage, ...args) {
    super(itemPackage, ...args);
    this._pausedAndFinished = false;
    this.timeLimit = 3;
  }

  show() {
    Logger.info('Quiz', 'Showing ' + this.quizType + ' quiz for ' + this.itemPackage.item.cue.text, this);

    this._quizTimer.finished = handleTimeout.bind(this);

    this.result.beginPhase('quiz');

    this.choices = [this.answer, this.distractor];

    if (!isDebugModeEnabled()) {
      this.choices = _.shuffle(this.choices);
    }

    // Convert the choices so the quizData reflects the appropriate structure.
    this.updateQuizData({
      choices: this.choices.map(choice => {
        return { 'text': choice, 'correct': choice === this.answer };
      }),
    });

    renderComponent.call(this, () => this._quizTimer.start(this.timeLimit));
  }

  _setDistractor(distractorSource) {
    const distractor = distractorSource[_.random(0, distractorSource.length - 1)];
    this.distractor = distractor.getText();
  }

  /**
   * There is some custom functionality because pausing the quiz
   * during the end animation should not allow proceeding to the next
   * quiz.
   */
  resume() {
    super.resume();

    // If the quiz is already done, move to the next quiz.
    if (this._pausedAndFinished) {
      this._pausedAndFinished = false;
      super.finishQuiz();
    }
  }

  /**
   * If the user has paused the app during the transition, we don't
   * want to go to the next quiz.
   */
  finishQuiz() {
    if (this.paused) {
      this._pausedAndFinished = true;
      return;
    }

    this._quizTimer.disable();
    super.finishQuiz();
  }
}

export default RapidChoiceBase;
